var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-bar-4",staticStyle:{"transform":"translateX(0px)"},attrs:{"id":"footer-bar"}},[_c('router-link',{attrs:{"to":{ name: 'homeyouth' }}},[_c('i',{staticClass:"fa fa-home"}),_c('span',[_vm._v(_vm._s(_vm.$t('home')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }